import { HTTPService, createHtppServiceInstance, JsonResultClass } from "./httpManager.js";
import { Config } from "../config/config.js";
import { MetaDataHelper } from "./metaDataHelper.js";
import { Entity, Metadata } from "../components/commonApp.js";
import { StringKeyDictionary, StringOrDate } from "../../commonInterfaces.js";
import ReactDOM from "react-dom";
import React from "react";
import {NotificationHelper} from "./notificationHelper.js";
export class Helper {
    public static setBusyIndicator = (on: boolean, indicatorElement?: HTMLElement)  => {
        //always exists 
        const element = document.getElementById("globalBusyIndicator");
        //already active on defined element?  
        const busyIndicatorId = element.dataset["busyIndicatorId"];

        //console.log("setBusyIndicator: ", on, indicatorElement, element, busyIndicatorId);

        if (on) {
            return new Promise<boolean>((resolve, _reject) => {
                if (Helper.isNullOrEmpty(busyIndicatorId)) {
                    const elementToActivate = indicatorElement ? indicatorElement : element;
                    element.dataset["busyIndicatorId"] = elementToActivate.id;
                    kendo.ui.progress($(elementToActivate), true);
                    setTimeout(_ => {
                        resolve(true);
                    }, 10);
                }
            });
        } else {
            return new Promise<boolean>((resolve, _reject) => {
                let elementToDeactivate: HTMLElement = null;

                //already activated element
                if (!Helper.isNullOrEmpty(busyIndicatorId)) {
                    elementToDeactivate = document.getElementById(busyIndicatorId);
                }

                //default "global"-div
                if (elementToDeactivate == null) {
                    elementToDeactivate = element;
                }
                element.dataset["busyIndicatorId"] = "";

                kendo.ui.progress($(elementToDeactivate), false);
                setTimeout(_ => {
                    resolve(false);
                }, 10);
            });
        }

    }

    public static getValueOrDefault(value: any, defaultValue: any): any {
        try {
            if (Helper.hasValue(value)) {
                return value;
            } else {
                return defaultValue;
            }
        } catch {
            return defaultValue;
        }
    }

    public static hasValue(member: any): boolean {
        return typeof member !== "undefined" && member !== null && (typeof member !== "number" || isFinite(member)); //isFinite(NaN) -> false
    }

    public static isNumber(member: any): boolean {
        return !isNaN(parseFloat(member)) && isFinite(member);
    }

    public static isNullOrEmpty(value: string): boolean {
        const isNull = !Helper.hasValue(value);
        const isEmpty = isNull ? true : Helper.isStringEmpty(value);
        return (isNull || isEmpty);
    }

    public static isStringEmpty(value: string): boolean {
        const trimedValue = value.toString().trim();
        return (trimedValue == "");
    }

    public static isObjectEmpty(obj: {}): boolean {
        return (Object.keys(obj).length === 0 && obj.constructor === Object);
    }
    public static getAttributeSavely(obj: {}, attribute: string) {
        try {
            if (Helper.isNullOrEmpty(attribute))
                return null;
            let result = null;
            Object.keys(obj).forEach((key: string) => {
                if (key.trim().toLowerCase() === attribute.trim().toLowerCase()) {
                    result = obj[key];
                }
            })
            return result;
        } catch {
            return null;
        }
    }
    public static containsAttribute = (obj: {}, attribute: string) => {
        let result = false;
        Object.keys(obj).forEach((key: string) => {
            if (key.trim().toLowerCase() === attribute.trim().toLowerCase()) {
                result = true;
            }
        });
        return result;


    }
    //https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
    public static getHashCode = (value: string) => {
        let hash: number = 0, chr: number;
        if (Helper.isNullOrEmpty(value) || value.length === 0)
            return hash;
        for (let i = 0; i < value.length; i++) {
            chr = value.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }

    public static getTranslations(keys: string[]): Promise<JsonResultClass<StringKeyDictionary<string>>> {
        if (__internal_translations) {
            const newDict = {};
            for (var k of keys) {
                newDict[k] = __internal_translations[k];
            }
            return new Promise(resolve => resolve({ Data: newDict, Code: 0, Message: null, Id: null, AdditionalData: null }));
        }

        return HTTPService.post<JsonResultClass<StringKeyDictionary<string>>>("TranslationService/GetTranslations", { keys: keys });
    }

    public static getTranslation(key: string): string {
        if (typeof __internal_translations !== 'undefined') {
            const res = __internal_translations[key];
            return res == null ? "" : res;
        }
        return null;
    }


    public static getValueByPathString(target: {}, path: string): any {
        var t = target;
        var parts = path.split(".");
        for (var i = 0; i < parts.length - 1; i++) {
            let bracketStart = parts[i].indexOf("[");
            if (bracketStart == -1) {
                t = t[parts[i]];
            }
            else {
                t = t[parts[i].substring(0, bracketStart)];
                let bracketEnd = parts[i].indexOf("]");
                t = t[parts[i].substring(bracketStart + 1, bracketEnd)];
            }
        }
        return t[parts[parts.length - 1]];
    }

    public static processTemplate(targetString: string, getMatchValue: (match: string) => string): string {
        return this.processCustomTemplate(targetString, "{{", "}}", getMatchValue);
    }

    public static processCustomTemplate(targetString: string, templateStart: string, templateEnd: string, getMatchValue: (match: string) => string): string {
        let filledTemplate = targetString;
        const regExp = new RegExp(`${templateStart}.*?${templateEnd}`, "gm");   // => /{{.*?}}/gm;
        const matches = filledTemplate.match(regExp)
        if (Array.isArray(matches)) {
            for (let i = 0; i < matches.length; i++) {
                const match = matches[i];
                const evalResult = getMatchValue(match.replace(templateStart, "").replace(templateEnd, ""));
                filledTemplate = filledTemplate.replace(match, evalResult);
            }
        }

        return filledTemplate;
    }

    public static updateEntity(entity, newEntity) {
        if (entity == newEntity) {
            return;
        }
        if (this.hasValue(entity.IndividualFields) && this.hasValue(newEntity.IndividualFields)) {
            $.extend(entity.IndividualFields, newEntity.IndividualFields);
            delete newEntity.IndividualFields;
        }
        $.extend(entity, newEntity);
    }

    public static getTwoDigits(value: number): string {
        return ("00" + value).slice(-2);
    }

    public static findIndex(jsonArr: Array<any>, property: string, value: any): number {
        var foundIdx = -1;
        $.each(jsonArr, function (idx, obj) {
            if (obj[property] == value)
                foundIdx = idx;
        });
        return foundIdx;
    }

    public static findObjIndex<T, K extends keyof T>(array: Array<T>, property: K, value: T[K]): number {
        var idx = -1;

        if (Array.isArray(array)) {
            for (let i = 0; i < array.length; i++) {
                if (array[i] && array[i][property] === value) {
                    idx = i;
                    break;
                }
            }
        }
        return idx;
    }

    public static getArrayItem<T, K extends keyof T>(array: Array<T>, property: K, value: T[K]): T {
        const index = this.findObjIndex(array, property, value);
        return index > -1 ? array[index] : null;
    }

    public static setArrayValues(target: Array<any>, newValues?: Array<any>) {
        target.length = 0;
        if (this.hasValue(newValues)) {
            for (let i = 0; i < newValues.length; i++) {
                target.push(newValues[i]);
            }
        }
    }

    public static getFirstDiffChar(nValue, oValue): string {
        let charToAdd = "";
        let newValue = nValue.replace(/ |\r?\n|\r/g, '');
        if (!this.hasValue(oValue)) {
            charToAdd = newValue.slice(-1);
        } else {
            let oldValue = oValue.replace(/ |\r?\n|\r/g, '');
            if (oldValue && newValue.length > oldValue.length) {
                for (let i = 0; i < newValue.length; i++) {
                    if (newValue.charAt(i) != oldValue.charAt(i)) {
                        charToAdd = newValue.charAt(i);
                        break;
                    }
                }
            }
        }
        return charToAdd;
    }

    public static keepLockAlive(ashxHandler, spID, tableName, intervalInMilliseconds) {
        const formData = new FormData();
        formData.append("id", spID);
        formData.append("tableName", tableName)
        return window.setInterval(_ => { createHtppServiceInstance().noBusyIndicator().post(ashxHandler, formData); }, intervalInMilliseconds);
    }

    public static releaseLock = (id: number, table: string) => {
        const headers = {
            type: 'application/json',
        };
        const data: any = { id: id, table: table };

        const blob = new Blob([JSON.stringify(data)], headers);
        navigator.sendBeacon(Config.baseUrl + "Locks/ReleaseLock", blob);
    }

    public static createResizableRegion(container: string) {
        return function () {
            let _initialized = false;
            const id = "#" + container;
            let $target = null;
            if ($(id).hasClass("region")) {
                $target = $(id);
            } else {
                $target = $(".region", $(id))
            }
            $target.resizable({
                handles: "e",
                minWidth: 500,
                resize: (event, ui) => {
                    if (!_initialized) {
                        const leftPart = $(".field__value__label", $(event.target));
                        if (leftPart.length !== 0) {
                            leftPart.css("width", $(leftPart[0]).css("width"));
                        }
                    }
                }
            });
            //maybe set parameters or callbacks later...
            return {};
        }();
    }

    public static createEmptyEntity(): Entity {
        return {
            IsNew: true,
            RecordRight: {
                CanRead: true,
                CanWrite: true
            },
            IndividualFields: [],
            IsWatchable: false,
            IsWatched: false
        };
    }

    public static buildQueryParameter(parameterName: string, value: any): string {
        return this.hasValue(value) ? (parameterName + "=" + encodeURIComponent(value)) : "";
    }

    public static buildUrl(baseUrl: string, paramsObject: object): string {
        const url = new URL(baseUrl);

        for (const key in paramsObject) {
            if (paramsObject.hasOwnProperty(key)) {
                url.searchParams.set(key, encodeURIComponent(paramsObject[key]));
            }
        }
        return url.toString();
    }

    public static evalEntityProperty<T>(propName: keyof T, handleEval: (expression: string) => any) {
        return handleEval("entity." + propName.toString());
    }

    public static getQueryStringParameters = (url: string = null): StringKeyDictionary<string> => {
        //https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript?answertab=votes#tab-top
        const a = url != null && url.indexOf("?") != -1 ? url.substr(url.indexOf("?") + 1).split('&') : window.location.search.substr(1).split('&');
        if (!Array.isArray(a) || a.length === 0) return {};

        const b = {};
        for (let i = 0; i < a.length; ++i) {
            if (a[i] !== "") {
                const p = a[i].split('=', 2);
                if (p.length == 1)
                    b[p[0]] = "";
                else
                    b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
            }
        }
        return b;
    }

    public static endsWith = (target: string, searchString: string, position?: number): boolean => {
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > target.length) {
            position = target.length;
        }
        position -= searchString.length;
        var lastIndex = target.lastIndexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    }

    public static tryParseJSON(json: string, emptyObjectOnError = false): any {
        try {
            return JSON.parse(json);
        } catch (ex) {
            return emptyObjectOnError ? {} : null;
        }
    }

    public static isDialogOpen = (): boolean => {
        return document.querySelectorAll('[role="dialog"]').length > 0;
    }

    public static addUrlParameter = (url: string, parameter: string): string => {
        if (Helper.hasValue(parameter) && parameter.trim() !== "") {
            if (url.indexOf(Config.baseUrl) === 0) {
                url = url.substr(Config.baseUrl.length);
            }
            if (url.toLowerCase().indexOf(parameter.toLowerCase()) === -1) {
                if (url.indexOf("?") === -1) {
                    url += "?" + parameter;
                } else if (url[url.length - 1] === "?") {
                    url += parameter;
                } else {
                    url += "&" + parameter;
                }
            }
        }

        return url;
    }

    public static addQueryStringParameters = (url: string, parameters: object) => {
        if (Helper.hasValue(parameters)) {
            for (let name in parameters) {
                let value = parameters[name];
                if (value instanceof Date) {
                    value = Helper.dates.getISODateString(value);
                }

                url = Helper.addUrlParameter(url, Helper.buildQueryParameter(name, value));
            }
        }

        return url;
    }

    public static createQueryStringParameters = (parameterName: string, values: any[]): string => {
        if (!values || values.length == 0)
            return `${parameterName}=${null}`
        return `${parameterName}=${values.join(`&${parameterName}=`)}`;
    }

    public static saveDataToStorage = (saveId: string, saveData: any, isJson: boolean, type: BrowserStorageType = BrowserStorageType.Local) => {
        if (typeof (Storage) !== "undefined") {
            const storage = type === BrowserStorageType.Local ? localStorage : sessionStorage;
            try {
                if (isJson) {
                    storage.setItem(saveId, saveData);
                }
                else {
                    storage.setItem(saveId, JSON.stringify(saveData));
                }
            } catch (e) {
                console.warn("Error saving to storage: " + e.message);
            }
        }
    }

    public static loadDataFromStorage = (saveId: string, type: BrowserStorageType = BrowserStorageType.Local): any => {
        if (typeof (Storage) !== "undefined") {
            const storage = type === BrowserStorageType.Local ? localStorage : sessionStorage;
            try {
                const storageData = storage.getItem(saveId);

                if (storageData != null && storageData != undefined) {
                    return JSON.parse(storageData);
                }
                else {
                    return undefined;
                }
            } catch (e) {
                console.warn("Error loading from storage: " + e.message);
            }
        }
    }

    public static removeDataFromStorage = (saveId: string, type: BrowserStorageType = BrowserStorageType.Local) => {
        if (typeof (Storage) !== "undefined") {
            const storage = type === BrowserStorageType.Local ? localStorage : sessionStorage;
            try {
                storage.removeItem(saveId);
            } catch (e) {
            }
        }
    }

    public static getScrollBarHeight = () => {
        const scrollable = $("<div>").width(100).height(100).css("overflow", "scroll").css("position", "absolute").css("top", "-9999px");
        $("body").append(scrollable);
        var heigth = Math.abs(scrollable[0].scrollHeight - scrollable.height());
        scrollable.remove();
        return heigth;
    }

    public static hasVerticalScrollBar = (target: HTMLElement | JQuery) => {
        const elem = target instanceof jQuery ? target[0] : target;
        return Helper.hasValue(target) ? elem.scrollHeight > elem.clientHeight : false;
    }

    public static hasHorizontalScrollBar = (target: HTMLElement | JQuery) => {
        const elem = target instanceof jQuery ? target[0] : target;
        return Helper.hasValue(target) ? elem.scrollWidth > elem.clientWidth : false;
    }

    public static escapeRegExp = (str: string): string => {
        var specials = [
            // order matters for these
            "-"
            , "["
            , "]"
            // order doesn't matter for any of these
            , "/"
            , "{"
            , "}"
            , "("
            , ")"
            , "*"
            , "+"
            , "?"
            , "."
            , "\\"
            , "^"
            , "$"
            , "|"
        ], regex = RegExp('[' + specials.join('\\') + ']', 'g');

        return str.replace(regex, "\\$&");
    }

    public static dates = {
        toDate: (date: string | Date, format?: string): Date => {
            const subResult: string = (typeof (date) == "string") ? date : kendo.toString(date, "g");
            return kendo.parseDate(subResult, format);
        },
        toTime: (date: string | Date, format?: string): number => {
            const subResult: string = (typeof (date) == "string") ? date : kendo.toString(date, "g");
            return kendo.parseDate(subResult, format).getTime();
        },
        addSeconds: (date: Date, seconds: number) => {
            const d = new Date(date.valueOf());
            d.setTime(d.getTime() + (seconds * 1000));
            return d;
        },
        addDays: (date: Date, days: number): Date => {
            const d = new Date(date.valueOf());
            d.setDate(d.getDate() + days);
            return d;
        },
        addMinutes: (date: Date, minutes: number): Date => {
            const d = new Date(date.valueOf());
            d.setTime(d.getTime() + minutes * 60 * 1000);
            return d;
        },
        addHours: (date: Date, hours: number): Date => {
            const d = new Date(date.valueOf());
            d.setTime(d.getTime() + hours * 60 * 60 * 1000);
            return d;
        },
        addMonths: (date: Date, months: number): Date => {
            const d = new Date(date.valueOf());
            d.setMonth(d.getMonth() + months);
            return d;
        },
        removeTime: (date: Date | string) => {
            const d = Helper.dates.toDate(date);
            return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
        },
        toString: (date: string | Date, withTime = false) => {
            let toConvert = null;
            if (date instanceof Date) {
                toConvert = date;
            } else {
                toConvert = kendo.parseDate(date);
            }

            if (withTime) {
                return kendo.toString(toConvert, 'g');
            } else {
                return kendo.toString(toConvert, 'd');
            }
        },
        dateDiffInDays: (start: string | Date, end: string | Date) => {
            if (!Helper.hasValue(start) || !Helper.hasValue(end)) {
                return 0;
            }

            let startDate: Date = null;
            if (start instanceof Date) {
                startDate = start;
            } else if (typeof start === "string") {
                startDate = kendo.parseDate(start);
            } else {
                return null;
            }

            let endDate: Date = null;
            if (end instanceof Date) {
                endDate = end;
            } else if (typeof end === "string") {
                endDate = kendo.parseDate(end);
            } else {
                return null;
            }

            const sUTC = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
            const eUTC = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

            return Math.floor((eUTC - sUTC) / 86400000); //milliseconds pe day
        },
        getISODateString: (date: string | Date, withoutMidnightTimeString: boolean = false): string => {
            let toFormat: Date = null;
            if (date instanceof Date) {
                toFormat = date;
            } else if (typeof date === "string") {
                toFormat = kendo.parseDate(date);
            } else {
                return null;
            }

            if (withoutMidnightTimeString && toFormat.getHours() == 0 && toFormat.getMinutes() == 0 && toFormat.getSeconds() == 0) {
                return toFormat.getFullYear() + "-" + Helper.getTwoDigits(toFormat.getMonth() + 1) + "-" + Helper.getTwoDigits(toFormat.getDate());
            }
            else {
                return toFormat.getFullYear() + "-" + Helper.getTwoDigits(toFormat.getMonth() + 1) + "-" + Helper.getTwoDigits(toFormat.getDate()) +
                    "T" + Helper.getTwoDigits(toFormat.getHours()) + ":" + Helper.getTwoDigits(toFormat.getMinutes()) + ":" + Helper.getTwoDigits(toFormat.getSeconds());
            }
        },
        getFirstOfMonth: (date?: StringOrDate): Date => {
            const source = Helper.hasValue(date) ? Helper.dates.toDate(date) : new Date();
            return new Date(source.getFullYear(), source.getMonth(), source.getDate());
        },
        getLastMonday: (date?: StringOrDate): Date => {
            const source = Helper.hasValue(date) ? Helper.dates.removeTime(date) : Helper.dates.removeTime(new Date());
            const dayOfWeek = source.getDay();
            const daysToSubstract = dayOfWeek === 0 ? 6 : (dayOfWeek === 1 ? 0 : dayOfWeek - 1);
            return new Date(source.setDate(source.getDate() - daysToSubstract));
        },
        // Umwandlung von Minuten seit Mitternacht in String, z.B. 390 -> 06:30 (lbzlist.zvon, ...)
        fromMinutesSinceMidnight: (minutesSinceMidnight) => {
            if (minutesSinceMidnight === "")
                return null;

            let isNegativ = minutesSinceMidnight < 0;
            if (isNegativ) {
                minutesSinceMidnight = minutesSinceMidnight * -1;
            }

            var hours = Math.floor(minutesSinceMidnight / 60);
            var minutes = Math.floor(minutesSinceMidnight % 60);

            var result = "";

            if (hours < 10)
                result += "0";
            result += hours.toString();

            result += ":";

            if (minutes < 10)
                result += "0";
            result += minutes.toString();

            if (isNegativ)
                result = "-" + result;

            return result;
        },
        // Umwandlung eines Strings in Minuten seit Mitternacht, z.B. 06:30 -> 390
        toMinutesSinceMidnight(timeString) {
            if (timeString == "24:00")
                return 1440;
            else if (timeString === null || timeString === "" || timeString === undefined)
                return null;
            else {
                var hours = parseInt(timeString.slice(0, 2));
                var minutes = parseInt(timeString.slice(3, 5));
                return (hours * 60) + minutes;
            }
        },
        /// Macht aus einer "ungültigen" Uhrzeit eine gültige im Format "HH:mm"
        /// Wird z.B. "12" übergeben ist der Rückgabewert "12:00".
        /// Bei "4" ist der Rückgabewert "04:00".
        /// Bei "231" ist der Rückgabewert "23:10" usw.
        // Bei > 24:00 oder ungültigen Uhrzeiten wie 12:99 wird 00:00 zurückgeliefert
        prepareTime(timeString) {
            let time = timeString.replace(":", "").replace(/_/g, "");

            if (time.length == 0 || time.Length > 4)
                return time;

            const timeInt = parseInt(time);
            if (timeInt && timeInt > 2359) {
                return "00:00";
            }

            if (time.length == 1 || (time[0] != "0" && time[0] != "1" && time[0] != "2"))
                time = "0" + time;

            while (time.length < 4)
                time += "0";

            const hours = parseInt(time.slice(0, 2));
            const minutes = parseInt(time.slice(2, 4));
            if ((hours > 24 || minutes > 59) || (hours == 24 && minutes > 0))
                return "00:00";

            time = time.slice(0, 2) + ":" + time.slice(2, 4);

            return time;
        },
        parseAspMVCDate: (mvcDate: string): Date => {
            if (typeof mvcDate === "string") {
                return new Date(parseInt(mvcDate.substr(6)));
            }

            return null;
        },
        getTimeAgo: (time) => {
            switch (typeof time) {
                case 'number':
                    break;
                case 'string':
                    time = +new Date(time);
                    break;
                case 'object':
                    if (time.constructor === Date) time = time.getTime();
                    break;
                default:
                    time = +new Date();
            }

            let oneMinuteAgo = Config.translations.datetime.xtimeunityago.replace("{zeit}", "1")
                .replace("{einheit}", Config.translations.datetime.minute);
            let oneMinuteFromNow = Config.translations.datetime.xtimeunityfromnow.replace("{zeit}", "1")
                .replace("{einheit}", Config.translations.datetime.minute);
            let oneHourAgo = Config.translations.datetime.xtimeunityago.replace("{zeit}", "1")
                .replace("{einheit}", Config.translations.datetime.hour);
            let oneHourFromNow = Config.translations.datetime.xtimeunityfromnow.replace("{zeit}", "1")
                .replace("{einheit}", Config.translations.datetime.hour);


            var time_formats = [
                [60, Config.translations.datetime.seconds, 1], // 60
                [120, oneMinuteAgo, oneMinuteFromNow], // 60*2
                [3600, Config.translations.datetime.minutes, 60], // 60*60, 60
                [7200, oneHourAgo, oneHourFromNow], // 60*60*2
                [86400, Config.translations.datetime.hours, 3600], // 60*60*24, 60*60
                [172800, Config.translations.datetime.yesterday, Config.translations.datetime.tomorrow], // 60*60*24*2
                [604800, Config.translations.datetime.days, 86400], // 60*60*24*7, 60*60*24
                [1209600, Config.translations.datetime.lastweek, Config.translations.datetime.nextweek], // 60*60*24*7*4*2
                [2419200, Config.translations.datetime.weeks, 604800], // 60*60*24*7*4, 60*60*24*7
                [4838400, Config.translations.datetime.lastmonth, Config.translations.datetime.nextmonth], // 60*60*24*7*4*2
                [29030400, Config.translations.datetime.months, 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
                [58060800, Config.translations.datetime.lastyear, Config.translations.datetime.nextyear], // 60*60*24*7*4*12*2
                [2903040000, Config.translations.datetime.years, 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
                [5806080000, Config.translations.datetime.lastcentury, Config.translations.datetime.nextcentury], // 60*60*24*7*4*12*100*2
                [58060800000, Config.translations.datetime.centuries, 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
            ];

            var seconds = (+new Date() - time) / 1000;
            let token = Config.translations.datetime.ago;
            let list_choice = 1;

            if (seconds < 30) {
                return Config.translations.datetime.justnow;
            }
            if (seconds < 0) {
                seconds = Math.abs(seconds);
                token = Config.translations.datetime.fromnow;
                list_choice = 2;
            }
            var i = 0,
                format;
            while (format = time_formats[i++])
                if (seconds < format[0]) {
                    if (typeof format[2] == 'string')
                        return format[list_choice];
                    else
                        return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
                }
            return time;
        },
        //compares two dates. returns -1 if the first date is smaller, 1 if the second date is smaller, 0 if they are equal.
        //if ignoreTime is true, it will be a "date comparison"; if it's false, "date-time comparison".
        //if one date is invalid, it returns null.
        compareMultiTypeDates: (first: Date | string, second: Date | string, ignoreTime: boolean): -1 | 0 | 1 => {
            let fValue: Date = null, sValue: Date = null;

            if (Helper.hasValue(first)) {
                fValue = typeof first === "string" ? kendo.parseDate(first) : first;
            }

            if (Helper.hasValue(second)) {
                sValue = typeof second === "string" ? kendo.parseDate(second) : second;
            }

            if (!Helper.hasValue(fValue) || !Helper.hasValue(sValue)) {
                return null;
            }

            const d1 = new Date(fValue.getTime());
            const d2 = new Date(sValue.getTime());

            if (ignoreTime) {
                d1.setHours(0, 0, 0, 0);
                d2.setHours(0, 0, 0, 0);
            }

            const t1 = d1.getTime();
            const t2 = d2.getTime();

            return t1 < t2 ? -1 : (t1 > t2 ? 1 : 0);
        },

        isDateInBetween: (date: Date | string, start: Date | string, end: Date | string): boolean => {
            let inBetween = Helper.dates.compareMultiTypeDates(date, start, true) != -1 && Helper.dates.compareMultiTypeDates(end, date, true) != -1;
            let equal = Helper.dates.compareMultiTypeDates(date, start, true) == 0 || Helper.dates.compareMultiTypeDates(date, end, true) == 0;

            return inBetween || equal;
        },

        //https://stackoverflow.com/questions/6117814/get-week-of-year-in-javascript-like-in-php
        getWeekNumber: (d: Date): number => {
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
            let yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            let weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
            return weekNo;
        },


        getSecToHHMM: (seconds) => {
            const value = Math.abs(seconds);
            const hours = Math.floor(value / 3600);
            const min = Math.floor((value - (hours * 3600)) / 60);
            return `${seconds < 0 ? '-' : ''}${hours < 10 ? '0' + hours : hours}:${min < 10 ? '0' + min : min}`
        },

        getMinToHHMM: (minutes) => {
            return Helper.dates.getSecToHHMM(minutes * 60);
        },

        getDayOfWeekLabel: (day: number) => {
            switch (day) {
                case 1:
                    return Helper.getTranslation("Standard.Sonntag");
                case 2:
                    return Helper.getTranslation("Standard.Montag");
                case 3:
                    return Helper.getTranslation("Standard.Dienstag");
                case 4:
                    return Helper.getTranslation("Standard.Mittwoch");
                case 5:
                    return Helper.getTranslation("Standard.Donnerstag");
                case 6:
                    return Helper.getTranslation("Standard.Freitag");
                case 7:
                    return Helper.getTranslation("Standard.Samstag");
                default:
                    return null;
            }
        },

        getDateFromJsonString: (jsonDate: any) => {
            if (typeof jsonDate === 'string') {
                let a = /\/Date\((\d*)\)\//.exec(jsonDate);
                if (a)
                    return new Date(+a[1]);
            }
            return null;
        },

        formatDateTime(date: Date, format: string) {
            const _padStart = (value: number): string => value.toString().padStart(2, '0');

            return format
                .replace(/yyyy/g, _padStart(date.getFullYear()))
                .replace(/dd/g, _padStart(date.getDate()))
                .replace(/mm/g, _padStart(date.getMonth() + 1))
                .replace(/hh/g, _padStart(date.getHours()))
                .replace(/ii/g, _padStart(date.getMinutes()))
                .replace(/ss/g, _padStart(date.getSeconds()));
        }
    }

    public static openInNewBrowserTab = (url: string) => {
        const dummyLink = $("<a>").text("click me!").attr({ href: url, target: "_blank" });
        $("body").append(dummyLink);
        dummyLink[0].click();
        dummyLink.remove();
    }

    //Kopiert aus PDF.js von Mozilla
    public static download = (blobUrl, filename) => {
        const a = document.createElement("a");
        if (!a.click) {
            throw new Error('DownloadManager: "a.click()" is not supported.');
        }
        a.href = blobUrl;
        a.target = "_parent";
        // Use a.download if available. This increases the likelihood that
        // the file is downloaded instead of opened by another PDF plugin.
        if ("download" in a) {
            a.download = filename;
        }
        // <a> must be in the document for recent Firefox versions,
        // otherwise .click() is ignored.
        (document.body || document.documentElement).appendChild(a);
        a.click();
        a.remove();
    }

    public static openFileInNewBrowserTab = (path: string) => {
        window.open(path, '_blank');
        //Wenn ein neuer tab geöffnet wird läuft er nicht weiter sondert beendet die Anwendung hier
        //Grund dafür ist aber unklar....
        throw new Error("Not allowed to load local resource");
    }

    public static convertToHtml = (input: string, returnOuter?: boolean) => {
        const e = document.createElement('div');
        e.innerHTML = input;
        if (e.childNodes.length == 1) {
            if (Helper.hasValue(returnOuter) && returnOuter === true) {
                return e.outerHTML;
            } else {
                return e.childNodes[0].nodeValue;
            }
        } else if (e.childNodes.length > 1) {
            if (Helper.hasValue(returnOuter) && returnOuter === true) {
                return e.outerHTML;
            } else {
                return e.innerHTML;
            }
        } else {
            return "";
        }
    }

    public static ColorNames = [
        'White', 'Black', 'Blue', 'Brown', 'Cyan', 'Magenta', 'Maroon', 'Lime', 'Navy', 'Pink', 'Orange', 'Red',
        'Yellow', 'Teal', 'Olive', 'Green', 'Violet', 'Fuchsia', 'SkyBlue', 'Silver',
        'AntiqueWhite', 'Aqua', 'Aquamarine', 'Azure', 'Beige', 'Bisque', 'BlanchedAlmond',
        'BlueViolet', 'BurlyWood', 'CadetBlue', 'Chartreuse', 'Chocolate', 'Coral', 'CornflowerBlue', 'Cornsilk',
        'Crimson', 'DarkBlue', 'DarkCyan', 'DarkGoldenRod', 'DarkGray', 'DarkGrey', 'DarkGreen', 'DarkKhaki',
        'DarkMagenta', 'DarkOliveGreen', 'DarkOrange', 'DarkOrchid', 'DarkRed', 'DarkSalmon', 'DarkSeaGreen', 'DarkSlateBlue',
        'DarkSlateGray', 'DarkSlateGrey', 'DarkTurquoise', 'DarkViolet', 'DeepPink', 'DeepSkyBlue', 'DimGray', 'DimGrey', 'DodgerBlue',
        'FireBrick', 'FloralWhite', 'ForestGreen', 'Gainsboro', 'GhostWhite', 'Gold', 'GoldenRod', 'Gray', 'Grey',
        'GreenYellow', 'HoneyDew', 'HotPink', 'IndianRed', 'Indigo', 'Ivory', 'Khaki', 'Lavender', 'LavenderBlush', 'LawnGreen', 'LemonChiffon',
        'LightBlue', 'LightCoral', 'LightCyan', 'LightGoldenRodYellow', 'LightGray', 'LightGrey', 'LightGreen', 'LightPink', 'LightSalmon',
        'LightSeaGreen', 'LightSkyBlue', 'LightSlateGray', 'LightSlateGrey', 'LightSteelBlue', 'LightYellow', 'LimeGreen', 'Linen',
        'MediumAquaMarine', 'MediumBlue', 'MediumOrchid', 'MediumPurple', 'MediumSeaGreen', 'MediumSlateBlue',
        'MediumSpringGreen', 'MediumTurquoise', 'MediumVioletRed', 'MidnightBlue', 'MintCream', 'MistyRose', 'Moccasin', 'NavajoWhite',
        'OldLace', 'OliveDrab', 'OrangeRed', 'Orchid', 'PaleGoldenRod', 'PaleGreen', 'PaleTurquoise', 'PaleVioletRed',
        'PapayaWhip', 'PeachPuff', 'Peru', 'Plum', 'PowderBlue', 'Purple', 'RebeccaPurple', 'RosyBrown', 'RoyalBlue',
        'SaddleBrown', 'Salmon', 'SandyBrown', 'SeaGreen', 'SeaShell', 'Sienna', 'SlateBlue', 'SlateGray', 'SlateGrey',
        'Snow', 'SpringGreen', 'SteelBlue', 'Tan', 'Thistle', 'Tomato', 'Turquoise', 'Wheat', 'WhiteSmoke', 'YellowGreen'];


    public static uploadFile = (accept: string[], asDataUrl: boolean = false): Promise<string | {}> => {
        return new Promise<string | {}>((resolve, reject) => {
            const id = kendo.guid();
            accept = Helper.getValueOrDefault(accept, []);
            const targetElement = $("<div>");
            $("body").append(targetElement);

            const destroy = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }

            const afterCreation = () => {
                let input = $(`#${id} input`);
                input.click();
            }
            const onChange = () => {
                const file = (document.querySelector('input[type=file]') as any).files[0];
                if (asDataUrl) {
                    if (file) {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                            resolve(reader.result);
                        }
                        reader.onerror = () => {
                            reject(reader.error);
                        }
                        reader.onabort = () => {
                            reject();
                        }
                    } else {
                        reject(file);
                    }
                } else {
                    resolve(file);
                }
                destroy();
            }
            ReactDOM.render(<div id={id} style={{ width: "0", height: "0" }}><input type="file" onChange={onChange} accept={accept.join(", ")}></input></div>, targetElement[0], afterCreation);

        });
    }

    public static formatString = (source: string, ...values: Array<any>) => {
        return source.replace(/{(\w+)}/g, (match, placeholder) => {
            return isNaN(placeholder) ? values[0][placeholder] :
                (typeof values[placeholder] != 'undefined' ? values[placeholder] : match);
        });
    }

    public static diagnostics = {
        trackMouse: () => {
            const elem = $("<div>");
            elem.css({ position: "fixed", top: 0, right: "100px", border: "1px solid black", color: "black", "background-color": "white" });
            $("body").append(elem).on("mousemove", function (e) {
                $(elem).text("x: " + e.clientX + ", y: " + e.clientY);
            });
        }
    }

    public static executeOnReadyState = (f: () => void) => {
        if (document.readyState === "complete") {
            f();
        } else {
            document.addEventListener('DOMContentLoaded', f);
        }
    }

    public static convertDelphiColor = (delphiColor: number) => {
        if (!Helper.hasValue(delphiColor)) {
            return "#000000";
        } else {
            const r = (delphiColor & 0x000000FF) >> 0;
            const g = (delphiColor & 0x0000FF00) >> 8;
            const b = (delphiColor & 0x00FF0000) >> 16;

            let rh = r.toString(16);
            rh = rh.length === 1 ? "0" + rh : rh;
            let gh = g.toString(16);
            gh = gh.length === 1 ? "0" + gh : gh;
            let bh = b.toString(16);
            bh = bh.length === 1 ? "0" + bh : bh;

            const hexColor = "#" + rh + gh + bh;

            return hexColor;
        }

    }

    public static isHex = (value: string) => {
        const re = /^[0-9a-fA-F]+$/g;
        return re.test(value);
    }

    public static getBrowserLanguage = () => {
        return navigator.language;
    }

    public static getBrowserLanguages = () => {
        return navigator.languages;
    }

    private static getUsedBrowser = () => {
        let sBrowser;
        const sUsrAg = navigator.userAgent;

        if ((sUsrAg.indexOf("Firefox") > -1) && (sUsrAg.indexOf("Seamonkey") == -1)) {
            sBrowser = "Firefox";
        } else if (sUsrAg.toLowerCase().indexOf("edg/") > -1) {
            sBrowser = "Edge";
        } else if ((sUsrAg.indexOf("Chrome") > -1) && (sUsrAg.indexOf("OPR") == -1) && (sUsrAg.indexOf("Opera") == -1)) {
            sBrowser = "Chrome";
        } else if (sUsrAg.toLowerCase().indexOf('safari/') > -1) {
            sBrowser = "Safari";
        } else {
            sBrowser = "unknown";
        }
        return sBrowser;
    }

    private static getOS = () => {
        const sUsrAg = navigator.userAgent;
        //mehr wird zurzeit nicht gebraucht
        if (sUsrAg.toLowerCase().indexOf("mac") > -1) {
            return "MacOS";
        } else {
            return "other";
        }
    }

    private static isBrowserSupported = (browser: string) => {
        const browsers = ["Edge", "Chrome", "Firefox", "Safari"];
        const support = browsers.indexOf(browser);
        return (support > -1);
    }

    private static getUsedVersion = () => {
        const sUsrAg = navigator.userAgent; //"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.1.2 Safari/605.1.15"; 
        const usedBrowser = Helper.getUsedBrowser();
        if (!Helper.isBrowserSupported(usedBrowser))
            return -1;
        const getVersion = (str: string) => {
            const exp = str + "\/([\d]*|\.)*";
            let regEx = new RegExp(exp);
            if (regEx.test(sUsrAg)) {
                let match = regEx.exec(sUsrAg)[0].split(" ")[0];
                let version = match.replace(str + "/", "");
                let arr = version.split(".");
                if (arr.length > 0) {
                    return parseInt(arr[0]);
                } else {
                    return -1;
                }
            }
        }
        switch (usedBrowser) {
            case "Edge":
                return getVersion("Edg");
            default:
                return getVersion(usedBrowser);
        }
    }

    private static isVersionSupported = () => {

        const usedBrowser = Helper.getUsedBrowser();
        return new Promise<boolean>((resolve) => {
            if (Helper.isBrowserSupported(usedBrowser)) {
                Helper.getSupportedVersion(usedBrowser).then((val) => {
                    const usedVersion = Helper.getUsedVersion();
                    resolve(usedVersion >= val)
                });
            } else {
                resolve(false);
            }
        });
    }

    private static getSupportedVersion = (browser: string) => {
        return new Promise<number>((resolve) => {
            HTTPService.get<JsonResultClass>('BrowserCompatibility/GetSupportedBrowsers')
                .then(result => {
                    const data = result.Data;
                    const version = data[browser];
                    resolve(version);
                });
        });
    }

    public static checkSupportedBrowser = () => {
        return new Promise<string>((resolve) => {
            Helper.isVersionSupported().then((support) => {
                const usedBrowser = Helper.getUsedBrowser();
                const wordWrap = " \n";
                let message: string = null;
                if (!Helper.isBrowserSupported(usedBrowser)) {
                    if (Config.user.languageId == 0) {
                        message = "Ihr Web Browser wird nicht unterstützt." + wordWrap
                            + "Bitte verwenden Sie einen der folgenden Browser:" + wordWrap
                            + "Edge" + wordWrap
                            + "Chrome" + wordWrap
                            + "Firefox";
                    } else {
                        message = "Your web browser is not supported." + wordWrap
                            + "Please use one of the following browsers:" + wordWrap
                            + "Edge" + wordWrap
                            + "Chrome" + wordWrap
                            + "Firefox";
                    }
                }
                if (!support && message == null) {
                    if (Config.user.languageId == 0) {
                        message = "Der verwendete Web Browser ist nicht aktuell." + wordWrap
                            + "Die volle Funktionalität der Software kann so nicht gewährleistet werden." + wordWrap
                            + "Bitte aktualisieren Sie Ihren Web Browser";
                    } else {
                        message = "The web browser used is not up-to-date." + wordWrap
                            + "The full functionality of the software cannot be guaranteed in this way." + wordWrap
                            + "Please update your web browser";
                    }

                }
                resolve(message);
            });
        });
    }

    public static getLocalDateformat = () => {
        return Helper.getValueOrDefault(kendo.culture().calendars.standard.patterns.d, "dd/mm/yyyy");
    }

    public static getPropValueCaseInsensitive = (obj: any, propName: string): any => {
        return obj[Object.keys(obj).filter(k => {
            return k.toLowerCase() === propName.toLowerCase();
        })[0]];
    }

    public static throttle = (func: Function, interval: number = 1000) => {
        return (_ => {
            let lastCall = null;
            return (...args) => {
                const previousCall = lastCall;
                lastCall = Date.now();
                if (previousCall === undefined || (lastCall - previousCall) > interval) {
                    func(...args);
                }
            }
        })();
    }

    public static groupBy<T>(arr: Array<T>, keyGetter: (obj: T) => any): Map<any, Array<T>> {
        const map = new Map();
        arr.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }

    public static getMetaData = (type: string): Promise<Metadata> => {
        return new Promise<Metadata>((resolve, reject) => {
            const url = type.toLowerCase().indexOf("metadata/") === 0 ? type : "MetaData/" + type;
            HTTPService.get<Metadata>(url)
                .then(metadata => {
                    const convertedMetadata = this.fixMetadata(metadata);
                    convertedMetadata.metaDataType = type;
                    resolve(convertedMetadata);
                })
                .catch(reject);
        });
    }

    public static fixMetadata = (metadata: Metadata): Metadata => {
        MetaDataHelper.setGUIDs(metadata);
        if (metadata.additional && metadata.additional.objects) {
            const translations = metadata.additional.objects.filter(o => o.name == "translations");
            if (translations && translations.length > 0) {
                translations[0].data = Object.assign(__internal_getNewTranslationsDictionary(), translations[0].data);
            }
            else {
                metadata.additional.objects.push({ name: "translations", data: __internal_getNewTranslationsDictionary() })
            }
        }

        const convertedMetadata = convertToNewFormat(metadata);

        return convertedMetadata;
    }

    public static formatNumber = (number: number, digits: number = 2) => {
        if (!Helper.hasValue(digits) || (digits < 0))
            digits = 0;
        if (!Helper.hasValue(number))
            number = 0;

        const sp = (number + '').split('.');
        if (sp[1] !== undefined)
            return (Math.round(number * 100) / 100).toFixed(digits);
        else
            return number;
    }

    public static truncateByDecimalPlace = (value: number, numDecimalPlaces: number): number => {
        const x = Math.trunc(value * Math.pow(10, numDecimalPlaces)) / Math.pow(10, numDecimalPlaces);
        //console.log("truncateByDecimalPlace=" + x);
        return x;
    }

    public static mergeLists = (...items: Array<any[] | any>) => {
        if (items.length === 0) {
            return [];
        }
        let result: any[] = [];

        for (let i = 0; i < items.length; i++) {
            if (Array.isArray(items[i])) {
                result = result.concat(items[i]);
            } else {
                result = result.concat([items[i]]);
            }
        }
        result = result.filter((value, index, self) => {
            return self.indexOf(value) === index;
        });
        return result;
    }

    public static debounce = (callback, delay) => {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(callback, delay);
        }
    }

    public static savelyToString = (value: any) => {
        const type = typeof value;

        switch (type) {
            case "bigint":
            case "number":
                return (value as number).toString()
            case "string":
                return value;
            case "boolean":
                return (value as boolean) ? "1" : "0";
            case "object":
                if (value instanceof Date) {
                    return (value as Date).getTime().toString();
                }
                return JSON.stringify(value);
            default:
                return ""
        }
    }

    public static isMobileDevice = () => {
        let hasTouchScreen = false;
        if ("maxTouchPoints" in navigator) {
            hasTouchScreen = navigator.maxTouchPoints > 0;
        } else if ("msMaxTouchPoints" in navigator) {
            hasTouchScreen = navigator["msMaxTouchPoints"] > 0;
        } else {
            const mQ = matchMedia?.("(pointer:coarse)");
            if (mQ?.media === "(pointer:coarse)") {
                hasTouchScreen = !!mQ.matches;
            } else if ("orientation" in window) {
                hasTouchScreen = true; // deprecated, but good fallback
            } else {
                // Only as a last resort, fall back to user agent sniffing
                const UA = navigator["userAgent"];
                hasTouchScreen =
                    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
            }
        }
        return hasTouchScreen;
    }

    public static useMobileGui = (): boolean => {
        let mobileGuiLocalStorageValue: boolean = Helper.loadDataFromStorage(`__${Config.user.userName}-useMobileGui__`) ?? false;
        return (mobileGuiLocalStorageValue && Config.settings.useMobileGui && Helper.isMobileDevice()) || Config.settings.isMobileApp;
    }

    public static getDefaultCellTemplate(field, value){
        return "#if(data."+field+" != null && data."+field+" != undefined && data."+field+" != '' && data."+field+" != \"\"){#<div class='gridCellTemplate'><div class='gridCellValue'>" + value + "</div><div class='copyGridCellButton'><div id='copyGridCellButtonIcon'><i class='fal fa-paste fa-fw'></i></div></div></div>#}#";
    }
    
    public static setDefaultCellTemplate(column){
        if(Helper.hasValue(column.template) && typeof column.template != "function"){
            column.template = Helper.getDefaultCellTemplate(column.field, column.template);
        }
        else if(!Helper.hasValue(column.template)){
            column.template = Helper.getDefaultCellTemplate(column.field, "#="+column.field+"#");
        }
    }
    public static setCopyCellButtonFunction(tbody: any) {
        tbody.find("td").find(".copyGridCellButton").on("click", function(ev){
            let toCopy = $(ev.currentTarget).parent("div").text();
            if(typeof toCopy == "string"){
                navigator.clipboard.writeText(toCopy);
                NotificationHelper.showInfoMessage(Helper.getTranslation("Standard.SavedToClipboard"));
            }
        });
        tbody.find("td").on("mouseenter", function(ev) {
            let cell = $(ev.currentTarget);
            cell.parent("tr").parent("tbody").find("td").find(".copyGridCellButton").hide();
            cell.find(".copyGridCellButton").show();
        });
        tbody.find("td").on("mouseleave", function(ev){
            let cell = $(ev.currentTarget);
            cell.find(".copyGridCellButton").hide();
        });
    }
    
    public static sanitizeHtml = (inputHtml: string): string => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(inputHtml, 'text/html');

        const dangerousTags = ['script', 'iframe', 'object', 'embed', 'form', 'link', 'meta', 'style'];
        dangerousTags.forEach(tag => {
            const elements = doc.querySelectorAll(tag);
            elements.forEach(el => el.remove());
        });

        const elementsWithOnAttributes = doc.querySelectorAll('[onerror], [onclick], [onload], [onmouseenter], [onmouseleave], [onchange], [onfocus], [onblur]');
        elementsWithOnAttributes.forEach(el => {
            const attrs = el.getAttributeNames();
            attrs.forEach(attr => {
                if (attr.startsWith('on')) {
                    el.removeAttribute(attr); 
                }
            });
        });
        
        const links = doc.querySelectorAll('a[href]');
        links.forEach(link => {
            const href = link.getAttribute('href');
            if (href && href.startsWith('javascript:')) {
                link.setAttribute('href', '#');
            }
        });
        
        const elementsWithStyles = doc.querySelectorAll('[style]');
        elementsWithStyles.forEach(el => {
            el.removeAttribute('style');
        });
        
        return doc.body.innerHTML;
    };
    static getPageTitle() {
        return Helper.hasValue(Config.pageTitle) ? Config.pageTitle : "Innosoft Field Service Management";
    }
}

export enum DocumentReferenceType {
    Address = 0,
    Machine = 1,
    Ticket = 2,
    Project = 3,
    Delegation = 4,
    Resource = 5,
    Article = 6,
    CommLineItem = 7,
    CustomReportTemplate = 8,
    CustomReport = 9,
    CustomReportQuestion = 10,
    ResourceSubObject = 12,
    Beleg = 13,
    TaskGroup = 14,
    RecurringTask = 15,
    WorkPackage = 16,
    CapacityRequirement = 17,
    CommDocument = 18,
    TravelReport = 19,
}

export enum BrowserStorageType {
    Local = 0, Session = 1
}

function getAdditionalMetadata(metadata: any, name: string) {
    if (!metadata || !metadata.additional || !metadata.additional.objects) {
        return null;
    }
    const matchedData: any[] = metadata.additional.objects.filter(d => d.name == name);
    if (matchedData && matchedData.length > 0) {
        return matchedData[0].data;
    }
    return null;
}

function convertToNewFormat(metadata: any): Metadata {
    return {
        browserTitle: metadata.browserTitle ?? getAdditionalMetadata(metadata, "browserTitle"),
        pageTitle: metadata.pageTitle ?? getAdditionalMetadata(metadata, "pageTitle"),
        rightDrawerContainer: metadata.rightDrawerContainer ?? getAdditionalMetadata(metadata, "rightDrawerContainer"),
        menuDataSource: metadata.menuDataSource ?? getAdditionalMetadata(metadata, "menuDataSource"),
        tabs: metadata.tabs,
        additional: metadata.additional,
        formatVersion: metadata.formatVersion,
        hideMenu: metadata.hideMenu
    };
}

export class AppMetadata implements Metadata {
    private _internalMetadata;

    constructor(metadata) {
        this._internalMetadata = metadata;
    }

    public get browserTitle(): string {
        return this._internalMetadata.browserTitle ?? getAdditionalMetadata(this._internalMetadata, "browserTitle");
    }

    public get pageTitle(): string {
        return this._internalMetadata.pageTitle ?? getAdditionalMetadata(this._internalMetadata, "pageTitle");
    }

    public get rightDrawerContainer() {
        return this._internalMetadata.rightDrawerContainer ?? getAdditionalMetadata(this._internalMetadata, "rightDrawerContainer");
    }

    public get menuDataSource() {
        return this._internalMetadata.menuDataSource ?? getAdditionalMetadata(this._internalMetadata, "menuDataSource");
    }

    public get tabs() {
        return this._internalMetadata.tabs;
    }

    public get formatVersion(): number {
        return this._internalMetadata.browserTitle ?? getAdditionalMetadata(this._internalMetadata, "browserTitle");
    }

    public get additional(): any {
        if (this._internalMetadata.additional && this._internalMetadata.additional.objects && this._internalMetadata.additional.objects.length > 0) {
            return { objects: this._internalMetadata.additional.objects.filter(i => i.name != "pageTitle" && i.name != "browserTitle" && i.name != "rightDrawerContainer" && i.name != "menuDataSource") };
        }
        return null;
    }
}

interface AfterMountCallbackInvokerProps extends React.PropsWithChildren { onAfterMount: Function }
export class AfterMountCallbackInvoker extends React.Component<AfterMountCallbackInvokerProps, any> {
    componentDidMount() {
        this.props.onAfterMount && this.props.onAfterMount();
    }
    render() { return this.props.children }
}